import { LicenseManager } from "ag-grid-enterprise";

export default function({ $config }, inject) {
  // console.log("Setup AGGrid /src/plugins/aggrid.js license key...");
  LicenseManager.setLicenseKey($config.AGGRID_KEY);
}
